/* One source, cited the way the path cites everything: by arXiv identifier
   where one exists, otherwise by venue, with its title. */
import { useTranslation } from 'react-i18next';
import { REFS } from '../data/refs';
import { refHref, refLabel } from '../engine/sources';

export function Source({ refKey, bare = false }: { refKey: string; bare?: boolean }) {
  const { t } = useTranslation();
  const row = REFS[refKey];
  if (!row) return null;
  const href = refHref(row);
  const label = refLabel(row);
  /* a row with neither an identifier nor a venue has nothing to print */
  if (!href && !label) return null;

  return (
    <span className={`fig-src${bare ? ' plain' : ''}`}>
      {!bare && <span>{t('refLabel')}</span>}
      {href ? (
        <a href={href} rel="noopener nofollow" target="_blank">
          {label}
        </a>
      ) : (
        <b>{label}</b>
      )}
      <span>{row.t}</span>
    </span>
  );
}
